import { gql } from '@apollo/client';

export const GET_CREATED_ACCOUNTS = gql /* GraphQL */ `
	query GetCreatedAccounts {
		currentUser {
			id
			superPalOf {
				id
			}
		}
	}
`;
